module.exports = __webpack_public_path__ + "static/img/ponum.fa1f177.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ponum.png
// module id = Ktm5
// module chunks = 1